import { render } from "./cp_tagShow.vue?vue&type=template&id=49f29018&scoped=true"
import script from "./cp_tagShow.vue?vue&type=script&lang=js"
export * from "./cp_tagShow.vue?vue&type=script&lang=js"

import "./cp_tagShow.vue?vue&type=style&index=0&id=49f29018&scoped=scoped&lang=less"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f29018"]])

export default __exports__